import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcEmptyAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 120,
		height: 120,
		rx: 60,
		fill: "#E9F0FF"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.1523 93.0454C26.3994 82.8217 37.0975 75.8199 49.442 75.8199H70.1528C82.6161 75.8199 93.4012 82.9572 98.5924 93.3417C89.2789 104.113 75.5322 110.944 60.1887 111C52.8824 110.974 45.9277 109.466 39.6133 106.762C32.4531 103.636 26.1495 98.9142 21.1523 93.0454ZM60.3807 68.6087C69.4452 68.6087 76.7935 61.309 76.7935 52.3043C76.7935 43.2997 69.4452 36 60.3807 36C51.3161 36 43.9678 43.2997 43.9678 52.3043C43.9678 61.309 51.3161 68.6087 60.3807 68.6087Z",
		fill: "white"
	})]
});
export default SvgIcEmptyAvatar;
